export const C0 = 16.35;
export const Db0 = 17.32;
export const Cs0 = Db0;
export const D0 = 18.35;
export const Eb0 = 19.45;
export const Ds0 = Eb0;
export const E0 = 20.60;
export const F0 = 21.83;
export const Gb0 = 23.12;
export const Fs0 = Gb0;
export const G0 = 24.50;
export const Ab0 = 25.96;
export const Gs0 = Ab0;
export const A0 = 27.50;
export const Bb0 = 29.14;
export const As0 = Bb0;
export const B0 = 30.87;
export const C1 = 32.70;
export const Db1 = 34.65;
export const Cs1 = Db1;
export const D1 = 36.71;
export const Eb1 = 38.89;
export const Ds1 = Eb1;
export const E1 = 41.20;
export const F1 = 43.65;
export const Gb1 = 46.25;
export const Fs1 = Gb1;
export const G1 = 49.00;
export const Ab1 = 51.91;
export const Gs1 = Ab1;
export const A1 = 55.00;
export const Bb1 = 58.27;
export const As1 = Bb1;
export const B1 = 61.74;
export const C2 = 65.41;
export const Db2 = 69.30;
export const Cs2 = Db2;
export const D2 = 73.42;
export const Eb2 = 77.78;
export const Ds2 = Eb2;
export const E2 = 82.41;
export const F2 = 87.31;
export const Gb2 = 92.50;
export const Fs2 = Gb2;
export const G2 = 98.00;
export const Ab2 = 103.83;
export const Gs2 = Ab2;
export const A2 = 110.00;
export const Bb2 = 116.54;
export const As2 = Bb2;
export const B2 = 123.47;
export const C3 = 130.81;
export const Db3 = 138.59;
export const Cs3 = Db3;
export const D3 = 146.83;
export const Eb3 = 155.56;
export const Ds3 = Eb3;
export const E3 = 164.81;
export const F3 = 174.61;
export const Gb3 = 185.00;
export const Fs3 = Gb3;
export const G3 = 196.00;
export const Ab3 = 207.65;
export const Gs3 = Ab3;
export const A3 = 220.00;
export const Bb3 = 233.08;
export const As3 = Bb3;
export const B3 = 246.94;
export const C4 = 261.63;
export const Db4 = 277.18;
export const Cs4 = Db4;
export const D4 = 293.66;
export const Eb4 = 311.13;
export const Ds4 = Eb4;
export const E4 = 329.63;
export const F4 = 349.23;
export const Gb4 = 369.99;
export const Fs4 = Gb4;
export const G4 = 392.00;
export const Ab4 = 415.30;
export const Gs4 = Ab4;
export const A4 = 440.00;
export const Bb4 = 466.16;
export const As4 = Bb4;
export const B4 = 493.88;
export const C5 = 523.25;
export const Db5 = 554.37;
export const Cs5 = Db5;
export const D5 = 587.33;
export const Eb5 = 622.25;
export const Ds5 = Eb5;
export const E5 = 659.25;
export const F5 = 698.46;
export const Gb5 = 739.99;
export const Fs5 = Gb5;
export const G5 = 783.99;
export const Ab5 = 830.61;
export const Gs5 = Ab5;
export const A5 = 880.00;
export const Bb5 = 932.33;
export const As5 = Bb5;
export const B5 = 987.77;
export const C6 = 1046.50;
export const Db6 = 1108.73;
export const Cs6 = Db6;
export const D6 = 1174.66;
export const Eb6 = 1244.51;
export const Ds6 = Eb6;
export const E6 = 1318.51;
export const F6 = 1396.91;
export const Gb6 = 1479.98;
export const Fs6 = Gb6;
export const G6 = 1567.98;
export const Ab6 = 1661.22;
export const Gs6 = Ab6;
export const A6 = 1760.00;
export const Bb6 = 1864.66;
export const As6 = Bb6;
export const B6 = 1975.53;
export const C7 = 2093.00;
export const Db7 = 2217.46;
export const Cs7 = Db7;
export const D7 = 2349.32;
export const Eb7 = 2489.02;
export const Ds7 = Eb7;
export const E7 = 2637.02;
export const F7 = 2793.83;
export const Gb7 = 2959.96;
export const Fs7 = Gb7;
export const G7 = 3135.96;
export const Ab7 = 3322.44;
export const Gs7 = Ab7;
export const A7 = 3520.00;
export const Bb7 = 3729.31;
export const As7 = Bb7;
export const B7 = 3951.07;
export const C8 = 4186.01;
export const Db8 = 4434.92;
export const Cs8 = Db8;
export const D8 = 4698.63;
export const Eb8 = 4978.03;
export const Ds8 = Eb8;
export const E8 = 5274.04;
export const F8 = 5587.65;
export const Gb8 = 5919.91;
export const Fs8 = Gb8;
export const G8 = 6271.93;
export const Ab8 = 6644.88;
export const Gs8 = Ab8;
export const A8 = 7040.00;
export const Bb8 = 7458.62;
export const As8 = Bb8;
export const B8 = 7902.13;
